import React from 'react';

function HomePage({ onContact, onProducts }) {
  return (
    <>
      <section className="hero">
        <div className="hero-content">
          <h1>Where Inspiration Meets Reality</h1>
          <p>
            At Woolworth Software, we bring your vision to life through cutting-edge software solutions tailored to your needs. Whether you're a startup looking for a game-changing app or an enterprise in need of a seamless digital transformation, our team of skilled developers, designers, and strategists is here to make it happen.
          </p>
          <p>
            With a passion for technology and a commitment to excellence, we build scalable, user-friendly, and future-ready software that drives success. Let's create something amazing together!
          </p>
          <div className="cta-buttons">
            <button className="btn btn-primary" onClick={onContact}>Get Started</button>
            <button className="btn btn-secondary" onClick={onProducts}>Our Products</button>
          </div>
        </div>
      </section>
      <section className="features">
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">💡</div>
            <h3>Innovation First</h3>
            <p>We leverage the latest technologies and methodologies to create innovative solutions that give you a competitive edge in your market.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>Scalable Solutions</h3>
            <p>Our software grows with your business. We build flexible, scalable applications that adapt to your changing needs and requirements.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Tailored Approach</h3>
            <p>Every project is unique. We take time to understand your specific goals and challenges to deliver customized solutions that exceed expectations.</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomePage;
